import { render } from "./InmateQuestionnaireList.vue?vue&type=template&id=63c3c430&ts=true"
import script from "./InmateQuestionnaireList.vue?vue&type=script&lang=ts"
export * from "./InmateQuestionnaireList.vue?vue&type=script&lang=ts"

import "./InmateQuestionnaireList.vue?vue&type=style&index=0&id=63c3c430&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__